import {connect} from "react-redux"
import {setIsInTertiaryNav, setTertiaryNavIndex} from "../../ducks/secondary-nav"
import State from "../../ducks/state"
import {setIsInPrimaryNav, setPrimaryNavIndex} from "../../ducks/primary-nav"

export const mapStateToProps = (state: State) => {
    const {
        template,
        request: {siteUrl, cleanSiteUrl},
        primarynav: {alignment},
        settings: {isTpSuperLite},
    } = state

    return {
        alignment,
        siteUrl: isTpSuperLite ? cleanSiteUrl : siteUrl,
        templating: template,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        deactivateIndex: () => {
            dispatch(setPrimaryNavIndex(-1, ""))
            dispatch(setIsInPrimaryNav(false))
            dispatch(setIsInTertiaryNav(false))
            dispatch(setTertiaryNavIndex(-1))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)
